export enum FieldNames {
	roleId = 'roleId',
	notAnonymous = 'notAnonymous',
	workStyleResults = 'workStyleResults',
}
